// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__13yGv","icon":"SortAdornment_icon__DzhbI","up":"SortAdornment_up__1zWzH","down":"SortAdornment_down__25B3s","active":"SortAdornment_active__3Tm6D"};